// Error class that allows us to attach additional information that sentry
// will extract and log when it catches
export class ContextError extends Error {
    public context: unknown;

    constructor(message: string, context: unknown) {
        super(message);
        this.context = context;
    }
}
